import request from "@/utils/request"

//注册
export function register(data) {
  return request({
    url: '/h5/H5register',
    method: 'post',
    data
  })
}

//  登录注册
export function login(data) {
  return request({
    url: '/h5/H5login',
    method: 'post',
    data,
  })
}

//  忘记密码
export function forGetlogin(data) {
  return request({
    url: '/h5/updatePassWord',
    method: 'put',
    data,
  })
}


//获取验证码
export function getSms(data) {
  return request({
    url: '/apiUser/getSms',
    method: 'get',
    params: data
  })
}

//  登录注册
export function loginSms(data) {
  return request({
    url: '/h5/h5LoginCode',
    method: 'post',
    data,
  })
}

//微信登录
export function wechatLogin(data) {
  return request({
    url: '/h5/wechatWebLogin',
    method: 'get',
    params: data,
  })
}


//微信登录手机号
export function wechatPhone(data) {
  return request({
    url: '/h5/wechatPhone',
    method: 'post',
    data,
  })
}
